import { EModalStatus } from 'shared/common/types/modal';
import { TApplicationState } from 'shared/common/types/redux';

export const selectModalStatus = (state: TApplicationState): EModalStatus => {
  return state.modalStatus.status;
};
